<!-- Контейнер под список -->
<div class="dx-grid" *ngIf="options">

  <div class="dx-grid__dimmer" *ngIf="isDisabled"></div>

  <div class="dx-grid__main dx-grid__main--registry">

    <!-- Пнель под тулбар грида -->
    <div class="dx-grid__head">
      <ng-container *ngIf="options.showToolbar">
        <dx-grid-toolbar [toolbarOptions]="options.toolbar"
                         [gridState]="stateObservable"
                         (action)="onToolbarAction($event)">
        </dx-grid-toolbar>
      </ng-container>
    </div>

    <!-- Тело грида -->
    <div class="dx-grid__body">

      <!-- Немного тупо, но если оставлять [rowData]="rows" в случае использования серверной модели данных -->
      <!-- AgGrid начинает сыпать варнингами в консоли -->
      <ng-container *ngIf="options.useServerSideDataModel; else clientSideAgGrid">
        <ag-grid-angular
          style="width: 100%; height: 100%;"
          class="ag-theme-balham"
          [gridOptions]="agGridOptions"
          (gridReady)="onAgGridReady($event)"
          [getRowHeight]="getRowHeight"
          [rowHeight]="rowHeight"
          (modelUpdated)="onAgGridModelUpdated($event)"
          (cellValueChanged)="onCellValueChanges($event)"
          (selectionChanged)="onRowSelection($event)"
          (columnResized)="onColumnResized($event)"
          (filterChanged)="onFilterChange($event)"
          (rowDataUpdated)="rowDataUpdated.emit($event)">
        </ag-grid-angular>
      </ng-container>

      <ng-template #clientSideAgGrid>
        <ag-grid-angular
          style="width: 100%; height: 100%;"
          class="ag-theme-balham"
          [gridOptions]="agGridOptions"
          [rowClassRules]="rowClassRules"
          (gridReady)="onAgGridReady($event)"
          (modelUpdated)="onAgGridModelUpdated($event)"
          (cellValueChanged)="onCellValueChanges($event)"
          (selectionChanged)="onRowSelection($event)"
          (columnResized)="onColumnResized($event)"
          (filterChanged)="onFilterChange($event)"
          [rowData]="rows"
          (rowDataUpdated)="rowDataUpdated.emit($event)">
        </ag-grid-angular>
      </ng-template>

    </div>

    <!-- Футер грида. -->
    <!-- Здесь можно реализовать кастомную пагинацию или что-то еще. -->
    <div class="dx-grid__foot"></div>

  </div>

</div>
